import { Link, Outlet, createFileRoute, useNavigate, useRouterState } from '@tanstack/react-router'
import { useAuthStore } from '@unsw/store/auth'
import { ProfileIcons, ProfileSidebar } from '@unsw/ui/components/composed/profile-sidebar'
import { ArrowLeft } from 'lucide-react'

export const Route = createFileRoute('/dashboard/profile')({
  component: ProfileLayout,
})

function ProfileLayout() {
  const { user } = useAuthStore()
  const navigate = useNavigate()
  const routerState = useRouterState()
  const currentPath = routerState.location.pathname

  // Check if user is a teacher (has teacher role)
  const isTeacher = user?.status === 'TEACHER'

  const profileLinks = [
    {
      href: '/dashboard/profile/personal-information',
      label: 'Personal Information',
      icon: ProfileIcons.PersonalInfo,
      show: true,
    },
    {
      href: '/dashboard/profile/preferred-accent',
      label: 'Preferred Accent',
      icon: ProfileIcons.PreferredAccent,
      show: !isTeacher, // Only show for students
    },
  ]

  return (
    <div className="container max-w-5xl py-8">
      {/* Back link */}
      <div className="mb-6">
        <Link
          to="/dashboard"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Dashboard
        </Link>
      </div>

      {/* Profile content with sidebar */}
      <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-6">
        {/* Sidebar */}
        <ProfileSidebar
          links={profileLinks}
          currentPath={currentPath}
          onNavigate={(href) => navigate({ to: href as '/dashboard/profile/personal-information' })}
        />

        {/* Content */}
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
